import React, { Suspense, lazy, useState } from "react";

const NewsletterDialog = lazy(() => import("@/components/NewsletterDialog"));

interface Props {
  trigger: React.ReactElement;
}

/**
 * Lädt den Newsletter-Dialog (inkl. Dialog-Bibliothek) erst beim ersten Klick.
 * Vorher wird nur der Button gerendert – das hält das Start-Bundle klein.
 */
const NewsletterDialogLazy: React.FC<Props> = ({ trigger }) => {
  const [mounted, setMounted] = useState(false);

  if (!mounted) {
    return React.cloneElement(trigger, {
      onClick: (e: React.MouseEvent) => {
        trigger.props.onClick?.(e);
        setMounted(true);
      },
    } as Partial<React.ComponentProps<"button">>);
  }

  return (
    <Suspense fallback={trigger}>
      <NewsletterDialog trigger={trigger} autoOpen />
    </Suspense>
  );
};

export default NewsletterDialogLazy;
